import { render, staticRenderFns } from "./ContactAddress.vue?vue&type=template&id=7823c195&"
import script from "./ContactAddress.vue?vue&type=script&lang=js&"
export * from "./ContactAddress.vue?vue&type=script&lang=js&"
import style0 from "./ContactAddress.vue?vue&type=style&index=0&id=7823c195&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports